import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	imports: [
		CommonModule,
		MatButtonModule,
		MatFormFieldModule,
		MatInputModule,
		MatSidenavModule,
		MatInputModule,
		MatTooltipModule,
		MatIconModule,
		MatTableModule,
		MatPaginatorModule,
		MatDialogModule,
		MatSelectModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatToolbarModule,
		MatSortModule,
		MatProgressBarModule,
		MatRadioModule,
		MatCheckboxModule,
		MatListModule,
		MatCardModule,
		MatExpansionModule,
		MatSlideToggleModule,
		MatAutocompleteModule,
		MatChipsModule,
		MatMenuModule,
		MatBadgeModule,
		MatSnackBarModule
	],
	exports: [
		MatButtonModule,
		MatFormFieldModule,
		MatInputModule,
		MatSidenavModule,
		MatInputModule,
		MatTooltipModule,
		MatIconModule,
		MatTableModule,
		MatPaginatorModule,
		MatDialogModule,
		MatSelectModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatToolbarModule,
		MatSortModule,
		MatProgressBarModule,
		MatRadioModule,
		MatCheckboxModule,
		MatListModule,
		MatCardModule,
		MatExpansionModule,
		MatSlideToggleModule,
		MatAutocompleteModule,
		MatChipsModule,
		MatMenuModule,
		MatBadgeModule,
		MatSnackBarModule
	],
	declarations: []
})
export class MaterialAngularModule { }